import { combineReducers } from 'redux'
import { CookieStorage } from 'redux-persist-cookie-storage'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'
import localStorage from 'redux-persist/lib/storage'

import atcClassifications from './atcClassifications'
import auth from './auth'
import authors from './authors'
import confirm from './confirm'
import content from './content'
import imagesTime from './imagesTime'
import interactionsType from './interactionsType'
import interactions from './interactions'
import keywords from './keywords'
import medications from './medications'
import medicationsTypes from './medicationsTypes'
import message from './message'
import namesDcb from './dcbNames'
import preRegistrations from './preRegistrations'
import probabilities from './probabilities'
import laboratories from './laboratories'
import medicationClassification from './medicationClassification'
import profiles from './profiles'
import ratings from './ratings'
import references from './references'
import searchTable from './searchTable'
import severities from './severities'
import specialities from './specialities'
import user from './user'
import readingTimes from './readingTimes'
import cids from './cids'
import bookVectorization from './bookVectorization'
import contentVectorization from './contentVectorization'

const persistConfig = {
  key: 'MANOLE_CONTEUDO',
  storage: localStorage,
}

const persistContent = {
  key: 'MANOLE_CONTEUDO',
  storage,
  blacklist: ['conteudoHtml'],
}

export default combineReducers({
  atcClassifications,
  auth: persistReducer(persistConfig, auth),
  authors,
  confirm,
  content: persistReducer(persistContent, content),
  imagesTime,
  interactionsType,
  interactions,
  keywords,
  laboratories,
  medications,
  medicationClassification,
  medicationsTypes,
  message,
  namesDcb,
  preRegistrations,
  probabilities,
  profiles,
  ratings,
  references,
  searchTable,
  severities,
  specialities,
  user,
  readingTimes,
  cids,
  bookVectorization,
  contentVectorization,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js